import logError from 'src/data/services/logError';
import { create } from 'zustand';
import { combine } from 'zustand/middleware';
import { Platform } from 'react-native';
import { ApiService } from 'src/data/services/Services';

interface AnalyticsState {
	isLoading: boolean;
	eventTimeSpent: number;
	eventTimeStart: number;
	eventTimeEnd: number;
}

const initialState: AnalyticsState = {
	isLoading: true,
	eventTimeSpent: 0,
	eventTimeStart: 0,
	eventTimeEnd: 0,
};

function postAnalytics(eventUuid: string, type: string, data?: unknown): Promise<unknown> {
	return ApiService.endpoints.analytics.post({ eventUuid, type, data });
}

export const useAnalyticsStore = create(
	combine(initialState, (set, get) => ({
		eventDeleted: (eventUuid: string) => {
			postAnalytics(eventUuid, 'eventDeleted', eventUuid).catch(logError);
		},

		eventTime: (eventUuid: string, type: 'start' | 'end') => {
			if (type === 'start') {
				set({ eventTimeStart: Math.floor(Date.now() / 1000) });
				return;
			}

			const { eventTimeStart } = get();
			const eventTimeEnd = Math.floor(Date.now() / 1000);
			const timeSpent = eventTimeEnd - eventTimeStart;
			set({ eventTimeEnd, eventTimeSpent: timeSpent });

			if (eventUuid.length > 0) {
				postAnalytics(eventUuid, 'eventTime', timeSpent).catch(logError);
			}
		},

		postEventOS: (eventUuid: string) => {
			postAnalytics(eventUuid, 'eventOS', Platform.OS).catch(logError);
		},

		timeTable: (eventUuid: string) => {
			postAnalytics(eventUuid, 'timeTable').catch(logError);
		},

		eventOpened: (eventUuid: string) => {
			postAnalytics(eventUuid, 'eventOpened', eventUuid).catch(logError);
		},

		pageOpened: (eventUuid: string, pageID: unknown) => {
			postAnalytics(eventUuid, 'pageOpened', pageID).catch(logError);
		},
	})),
);
